import moment from "moment";

export default function transformServerTimestamp(
  serverTimestamp: number
): string {
  return moment.unix(serverTimestamp).format();
}
